import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import _isUndefined from 'lodash/isUndefined';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import { getElementTextLength, getPartialElement } from './utils';

const useStyles = makeStyles(theme => ({
  readMoreBtn: {
    color: props => props.color || theme.palette.primary.main,
    cursor: 'pointer',
  },
  moreLessBtn: {
    width: 100,
    height: 30,
    borderRadius: 2,
    border: '1px solid #E3E3E3',
    color: '#0862C0',
    ...theme.typography.button,
    fontSize: '0.65rem',
    float: 'right',
  },
}));

const ReadMoreLessWrapper = ({
  children,
  limit,
  color,
  withButton,
  expand,
  buttonHandler,
  readMoreLessHandler,
  hideReadText,
}) => {
  const classes = useStyles({ color });
  const hasLimit = useMemo(() => !_isUndefined(limit), [limit]);
  const [shortMode, setShortMode] = useState(hasLimit);
  const expansionHandler = () => {
    if (readMoreLessHandler) readMoreLessHandler(shortMode);
    setShortMode(!shortMode);
  };
  const shortened = useMemo(
    () => short(children, limit, expansionHandler, color, hideReadText),
    [limit],
  );
  return (
    <>
      {hasLimit && shortMode ? (
        <>{shortened}</>
      ) : (
        <>
          {children}
          {withButton && (
            <ButtonBase onClick={buttonHandler} className={classes.moreLessBtn}>
              Read {expand ? 'Less' : 'More'}
            </ButtonBase>
          )}
          {hasLimit && !shortMode && !hideReadText && (
            <span
              role="button"
              onClick={expansionHandler}
              onKeyDown={expansionHandler}
              tabIndex={0}
              className={classes.readMoreBtn}
            >
              &nbsp;Read Less
            </span>
          )}
        </>
      )}
    </>
  );
};

function short(arr, maxLen, readMore, color, hideReadText) {
  let finalArr;
  if (
    (arr.length === 2 && typeof arr[1] === 'boolean') ||
    (arr.length === 3 && typeof arr[2] === 'boolean')
  ) {
    [finalArr] = arr;
  } else {
    finalArr = arr;
  }
  let l = 0;
  for (let i = 0; i < finalArr.length; i += 1) {
    const elementLength = getElementTextLength(finalArr[i]);
    if (l + elementLength > maxLen) {
      const res = finalArr.slice(0, i);
      const partial = getPartialElement(
        finalArr[i],
        maxLen - l,
        readMore,
        color,
        hideReadText,
      );
      res.push(partial);
      return res;
    }
    l += elementLength;
  }
  return finalArr;
}

ReadMoreLessWrapper.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  limit: PropTypes.number,
  withButton: PropTypes.bool,
  buttonHandler: PropTypes.func,
  readMoreLessHandler: PropTypes.func,
  expand: PropTypes.bool,
  hideReadText: PropTypes.bool,
};

export default ReadMoreLessWrapper;
